import { styled } from "simplydo/react/styled";

import { useAppSelector } from "store";

import NotificationTray from "components/lib/Notifications";

const NotificationsContainer = styled.div`
  background-color: #fff;
  padding: 1rem;
`;

const MobileNotificationsWidget = () => {
  const user = useAppSelector((state) => state.user);

  if (!user) return null;
  return (
    <NotificationsContainer>
      <NotificationTray isMobile />
    </NotificationsContainer>
  );
};

export default MobileNotificationsWidget;
